import { useCallback } from 'react';
import { useEventListener } from './use-event-listener';
/**
 * Binds touch event listeners to the given container to prevent any multi-touch gestures from being handled by the browser.
 */
export function usePreventDefaultMultiTouch(elementRef) {
    const handleTouchEvent = useCallback((event) => {
        if (event.touches.length > 1) {
            event.preventDefault();
        }
    }, []);
    useEventListener(elementRef, 'touchstart', handleTouchEvent, { passive: false });
    useEventListener(elementRef, 'touchmove', handleTouchEvent, { passive: false });
}
//# sourceMappingURL=use-prevent-default-multi-touch.js.map